import { render, staticRenderFns } from "./MemoryCard.vue?vue&type=template&id=b9b155de&scoped=true&"
import script from "./MemoryCard.vue?vue&type=script&lang=ts&"
export * from "./MemoryCard.vue?vue&type=script&lang=ts&"
import style0 from "./MemoryCard.vue?vue&type=style&index=0&id=b9b155de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b155de",
  null
  
)

export default component.exports